import { toHumanDate } from '@/utils'

export default {
  computed: {
    currLocale () {
      return this.$i18n.locale
    }
  },

  methods: {
    /**
     * @param {Date | string | number} incomingDate
     * @param {string} timeZone
     * @return {string}
     */
    toHumanDate (incomingDate, timeZone) {
      return toHumanDate(incomingDate, this.currLocale, timeZone)
    }
  }
}
